
import { z } from "zod";

export const TicketHistoryFieldValues = ["deletedAt", "title", "description", "status", "priority", "projectId", "assigneeId", "teamId", "followUpDate", "resolutionNotes", "category", "subcategory", "tags"] as const;
export const TicketHistoryFieldSchema = z.enum(TicketHistoryFieldValues);
export const TicketHistoryField = TicketHistoryFieldSchema.enum;
export type TicketHistoryField = (typeof TicketHistoryFieldValues)[number];
